/**
 * Status badge for the carrier view. A carrier sees Supplier Confirmed,
 * dispatched and delivered loads
 * (``call_off.logistics_scope.LOGISTICS_VISIBLE_STATUSES``).
 *
 * CR-7781: labels and colours come from callOffStatus, the same ones the
 * customer and the supplier read, plus Logistics Confirmed once the haulier
 * has confirmed the load.
 */
import CallOffStatusBadges from '../CallOffStatusBadges';

interface LogisticsStatusBadgeProps {
  status: string;
  /** The call-off's `logistics_confirmed_at`. */
  logisticsConfirmedAt?: string | null;
}

export default function LogisticsStatusBadge({ status, logisticsConfirmedAt }: LogisticsStatusBadgeProps) {
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <CallOffStatusBadges status={status} logisticsConfirmedAt={logisticsConfirmedAt} />
    </span>
  );
}
